import styled from '@emotion/styled';
import ArrowNext from '@engineering/icons/arrow-next';
import { InteractiveText } from '@silvertours/front-shared';

export const Anchor = styled.a`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.brand.green140};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.brand.green100};
  }

  &:focus-visible {
    border-radius: ${({ theme }) => theme.radius.xs};
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }
`;

export const Text = styled(InteractiveText)`
  margin-right: ${({ theme }) => theme.spacing[60]};
`;

export const ArrowNextIcon = styled(ArrowNext)`
  height: ${({ theme }) => theme.spacing[50]};
  width: ${({ theme }) => theme.spacing[50]};
  flex-shrink: 0;
  fill: currentcolor;
`;
